module.exports = __webpack_public_path__ + "euro_2020_website_banners_copenhagen-4b59c0e0daafac0ea54abd6416f47b5d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/euro_2020_website_banners_copenhagen.png
// module id = 1371
// module chunks = 1